import React from "react";
import {
  PageWrapper,
  Container,
  Title,
  Paragraph,
  Ornament,
  OrnLine,
  List,
  ListItem,
  Divider,
  SectionTitle,
} from "./TermsAndConditionsPageStyles";

export default function TermsAndConditionsPage() {
  return (
    <PageWrapper>
      <Container>
        <Title>Termeni și Condiții</Title>

        <Ornament>
          <OrnLine />
        </Ornament>

        <SectionTitle>Prevederi generale</SectionTitle>

        <Paragraph>
          <strong>1.1</strong> Website-ul – <strong>www.ahavacakes.ro</strong>{" "}
          („Website-ul”) este proprietatea{" "}
          <strong>S.C. VIBE’ART MARROX SOLUTION SRL</strong>, societate juridică
          de naționalitate română, înregistrată la Oficiul Registrului
          Comerțului sub nr. <strong>J2017000733029</strong>, având Cod Unic de
          Înregistrare <strong>RO34829837</strong>, cu sediul social în{" "}
          <strong>Arad</strong>,{" "}
          <strong>
            str. Elena Ghiba Birta nr 6-8, apartament 6, Demisol, jud. Arad
          </strong>
          , denumită pe parcursul acestor Termeni și Condiții,{" "}
          <strong>„Ahava Cakes”</strong>.
        </Paragraph>

        <Paragraph>
          <strong>1.2</strong> Comercializarea Produselor prin intermediul
          Website-ului – Produsele („Produse”) oferite sunt cele enumerate în
          catalogul publicat pe Website, în limita stocurilor disponibile.
          Produsele pe care Ahava Cakes le oferă Clienților săi sunt realizate
          la standarde ridicate de calitate. Ahava Cakes este specializată în
          realizarea și vânzarea mai multor tipuri de prăjituri –{" "}
          <strong>
            ChocoAmour, București Élégance, Étoile, Polar Bliss, Ruby Doboș,
            D’or Pavlova, Velour Vanille, Coconut, Choux de Rêve, Éclair
            Prestige, Gâteau Noir, Velour Rouge, Émeraude, Éclat de Fruits,
            Macaron d’Amour, Muffeline, Verrine Élégance, cookies, bezele,
            negresă, platouri cu prăjituri asortate, produse de patiserie
          </strong>{" "}
          și alte tipuri de torturi și cutii cadou. Ahava Cakes este un brand
          românesc, în care îmbinăm tradiția și inovația, adaptăm rețete clasice
          tehnicilor moderne, pentru a rezulta un produs unic și de o calitate
          remarcabilă.
        </Paragraph>

        <Paragraph>
          <strong>1.3</strong> Utilizatorul Website-ului este:
        </Paragraph>

        <List>
          <ListItem>
            Persoană fizică, în vârstă de cel puțin 18 ani, cu capacitate de
            exercițiu deplină;
          </ListItem>
          <ListItem>
            Orice reprezentant al unei persoane juridice înmatriculate și
            funcționând în conformitate cu legile din România, acționând în
            numele și pe seama persoanei juridice;
          </ListItem>
          <ListItem>
            Orice persoană fizică autorizată (PFA), care accesează, comandă sau
            achiziționează Produse prin intermediul Website-ului, denumită pe
            parcursul acestor Termeni și Condiții „Client”.
          </ListItem>
        </List>

        <Paragraph>
          <strong>1.4</strong> Aria de aplicare a Termenilor și Condițiilor –
          Termenii și Condițiile definesc condițiile de utilizare a Website-ului
          și condițiile contractuale ce guvernează relația dintre Ahava Cakes și
          Client. Prin acceptarea Termenilor și Condițiilor, Clientul este de
          acord că:
        </Paragraph>

        <List>
          <ListItem>
            În cazul în care Clientul este o persoană fizică, acesta acționează
            în nume propriu și nu reprezintă nicio altă persoană, iar dacă este
            reprezentantul unei persoane juridice, acționează în limitele
            împuternicirii ce i-a fost acordată;
          </ListItem>
          <ListItem>
            Clientul va furniza informații corecte și complete în vederea
            utilizării Website-ului;
          </ListItem>
          <ListItem>
            Clientul nu va utiliza Website-ul pentru a reproduce, duplica,
            copia, vinde, revinde, distribui, publica sau exploata, în niciun
            scop comercial, software-ul, conținutul, ofertele, produsele sau
            serviciile furnizate de către Ahava Cakes, sau obținute prin
            intermediul Website-ului fără să obțină consimțământul expres,
            prealabil și scris al Ahava Cakes;
          </ListItem>
          <ListItem>
            Clientul nu va utiliza Website-ul în niciun mod care ar putea să
            afecteze în mod negativ disponibilitatea resurselor sale sau
            utilizarea sa de către alți Clienți;
          </ListItem>
          <ListItem>
            Clientul nu va utiliza Website-ul în orice scop care este ilegal sau
            interzis prin acești Termeni și Condiții sau prin alte politici
            relevante.
          </ListItem>
        </List>

        <Paragraph>
          <strong>1.5</strong> Acceptarea Termenilor și Condițiilor – Prin
          accesarea și utilizarea Website-ului, Clientul ia cunoștință de și
          acceptă prezenții Termeni și Condiții, precum și celelalte politici
          relevante pentru Website.
        </Paragraph>

        <Paragraph>
          <strong>1.6</strong> Modificarea Termenilor și Condițiilor – Ahava
          Cakes își rezervă dreptul de a modifica unilateral în orice moment
          Termenii și Condițiile, precum și orice alte politici relevante.
          Continuarea folosirii Website-ului ulterior modificării acestora
          reprezintă acceptul Clientului cu privire la modificările efectuate.
          Ultima actualizare a Termenilor și Condițiilor a fost efectuată în
          data de: <strong>30.10.2025</strong>.
        </Paragraph>

        <Paragraph>
          <strong>1.7</strong> Accesibilitatea Website-ului – Website-ul este
          accesibil clienților 24 de ore din 24, 7 zile din 7, cu excepția
          perioadelor de mentenanță. Ahava Cakes nu poate fi ținută
          răspunzătoare pentru lipsa de funcționalitate sau pentru funcționarea
          neconformă a Website-ului.
        </Paragraph>

        <Divider />

        <SectionTitle>Utilizarea Website-ului</SectionTitle>

        <SectionTitle>2.1 Crearea unui cont de către Client</SectionTitle>

        <Paragraph>
          Pentru efectuarea de cumpărături prin intermediul Website-ului,
          Clientul are posibilitatea de a achiziționa Produse fără a avea un
          cont pe Website, sau poate alege să își creeze un astfel de cont,
          pentru a facilita comenzile viitoare.
        </Paragraph>

        <Paragraph>
          Clientul este responsabil pentru menținerea confidențialității datelor
          asociate contului său creat pe Website. Datele solicitate la momentul
          realizării contului sunt necesare pentru gestionarea comenzilor și a
          relațiilor comerciale dintre Ahava Cakes și Client.
        </Paragraph>

        <Paragraph>
          Clienții sunt obligați să furnizeze date adevărate, exacte și complete
          și să le actualizeze ori de câte ori este necesar. În cazul furnizării
          unor informații inexacte sau incomplete, Ahava Cakes își rezervă
          dreptul de a suspenda sau desființa contul.
        </Paragraph>

        <Paragraph>
          Clientul este în întregime responsabil pentru menținerea securității
          și confidențialității contului și a parolei și pentru toate
          activitățile efectuate prin intermediul contului.
        </Paragraph>

        <Paragraph>
          În cazul pierderii sau uitării parolei, aceasta poate fi regenerată
          accesând secțiunea „Contul meu” și introducând adresa de e-mail.
        </Paragraph>

        <Paragraph>
          Clientul care dorește dezactivarea contului său are posibilitatea să
          efectueze această acțiune urmând instrucțiunile din Website sau
          scriindu-ne pe adresa <strong>office@ahavacakes.ro</strong>.
        </Paragraph>

        <SectionTitle>
          2.2 Produsele Ahava Cakes oferite spre comercializare
        </SectionTitle>

        <Paragraph>
          Fiecare tip de Produs oferit spre vânzare pe Website este însoțit de o
          descriere a acestuia, permițând Clientului să ia cunoștință de
          informațiile esențiale cu privire la caracteristicile acestuia înainte
          de a finaliza o comandă. Imaginile folosite pentru descrierea
          Produselor pe Website nu reprezintă o obligație contractuală, fiind
          utilizate exclusiv cu titlu de prezentare.
        </Paragraph>

        <Paragraph>
          Informațiile afișate pe Website au doar scop informativ și nu sunt
          destinate să înlocuiască sfatul unor specialiști.
        </Paragraph>

        <SectionTitle>
          2.3 Disponibilitatea Produselor și valabilitatea ofertelor
        </SectionTitle>

        <Paragraph>
          Ofertele de Produse și prețurile afișate pe Website sunt valabile atât
          timp cât sunt vizibile pe Website și în limita stocului disponibil.
        </Paragraph>

        <SectionTitle>2.4 Prețurile Produselor</SectionTitle>

        <Paragraph>
          Prețurile Produselor prezentate pe Website sunt exprimate în LEI și au
          toate taxele incluse. Prețurile aplicabile sunt cele afișate pe
          Website în momentul validării comenzii de către Client.
        </Paragraph>

        <SectionTitle>
          2.5 Plasarea Comenzii și încheierea contractului de vânzare
        </SectionTitle>

        <Paragraph>
          Efectuarea de comenzi tip click & collect prin intermediul
          Website-ului se poate realiza național pentru toate produsele listate,
          însă produsele nu se livrează, ci se ridică personal sau prin terțe
          persoane.
        </Paragraph>

        <Paragraph>
          În prezent, livrarea produselor Ahava Cakes nu este disponibilă, fiind
          disponibilă numai metoda de <strong>click & collect</strong>.
        </Paragraph>

        <Paragraph>
          În vederea efectuării și înregistrării unei comenzi, Clientul trebuie
          să urmeze instrucțiunile afișate pe Website. Comanda se validează
          printr-un click pe butonul „PLATĂ ONLINE”.
        </Paragraph>

        <Paragraph>
          Prin validarea comenzii, Clientul acceptă că această comandă implică o
          obligație de a plăti și își dă acordul cu privire la acești Termeni și
          Condiții.
        </Paragraph>

        <Paragraph>
          Ahava Cakes confirmă înregistrarea comenzii printr-un e-mail automat
          trimis către Client, care va conține lista produselor, prețul,
          magazinul de ridicare, intervalul ales și factura aferentă.
        </Paragraph>

        <Paragraph>
          Pentru comenzile efectuate prin intermediul Website-ului pentru care
          Clientul optează să le ridice personal din magazinele Ahava Cakes, nu
          există o valoare minimă de comandă.
        </Paragraph>

        <Paragraph>
          Condițiile pentru plasarea comenzilor sunt următoarele:
        </Paragraph>

        <List>
          <ListItem>
            Pentru a ne asigura că fiecare desert este pregătit cu grijă și
            atenție la detalii, vă rugăm să respectați termenele de comandă.
          </ListItem>
          <ListItem>
            Torturile din colecția Ahava Cakes se comandă cu minimum{" "}
            <strong>48 ore</strong> înainte de data dorită pentru ridicare.
          </ListItem>
          <ListItem>
            Torturile personalizate necesită un timp de pregătire mai mare și se
            comandă cu minimum <strong>5 zile</strong> înainte.
          </ListItem>
          <ListItem>
            Fiecare tort este realizat artizanal, cu ingrediente naturale, de
            aceea timpul de pregătire este esențial pentru calitatea produsului
            final.
          </ListItem>
        </List>

        <Paragraph>Comenzile pot fi plasate:</Paragraph>

        <List>
          <ListItem>telefonic / WhatsApp;</ListItem>
          <ListItem>prin formularul de comandă de pe website;</ListItem>
          <ListItem>direct la geamul laboratorului Ahava Cakes.</ListItem>
        </List>

        <Paragraph>
          Vă recomandăm să plasați comenzile din timp, mai ales pentru perioade
          aglomerate, pentru a vă asigura că putem onora cererea.
        </Paragraph>

        <SectionTitle>2.6 Plata Produselor</SectionTitle>

        <Paragraph>
          Plata comenzilor realizate se poate efectua în următoarea modalitate:
        </Paragraph>

        <List>
          <ListItem>Plata online prin card bancar.</ListItem>
        </List>

        <Paragraph>
          Toate tranzacțiile bancare de pe Website vor fi efectuate într-o
          manieră securizată, procesatorul de plăți fiind garantul acestei
          securități.
        </Paragraph>

        <Paragraph>
          Toate informațiile introduse în vederea efectuării unei plăți online
          nu vor fi stocate pe serverele Ahava Cakes, ci vor fi procesate
          exclusiv de către unitățile bancare emitente ale cardurilor.
        </Paragraph>

        <Paragraph>
          Pentru comenzile plasate pe Website se va emite automat factură
          fiscală în format electronic, transmisă pe e-mail.
        </Paragraph>

        <SectionTitle>2.7 Ridicarea produselor</SectionTitle>

        <List>
          <ListItem>
            Ridicarea Produselor de la punctul de lucru indicat de către Client
            în momentul efectuării comenzii.
          </ListItem>
        </List>

        <Paragraph>
          Ahava Cakes se angajează să răspundă tuturor cererilor și
          reclamațiilor în cel mult 5 zile lucrătoare de la primirea acestora.
        </Paragraph>

        <Paragraph>
          În caz de întârziere a ridicării Produselor comandate, Clientul este
          rugat să contacteze Ahava Cakes la numărul{" "}
          <strong>0775 107 107</strong>.
        </Paragraph>

        <SectionTitle>2.8 Dreptul de retragere</SectionTitle>

        <Paragraph>
          La recepționarea comenzii, Clientul trebuie să se asigure că Produsele
          corespund din punct de vedere calitativ și cantitativ așteptărilor
          sale.
        </Paragraph>

        <Paragraph>
          Potrivit prevederilor OUG nr. 34/2014, dreptul de retragere nu se
          aplică contractelor având drept obiect furnizarea de Produse care sunt
          susceptibile a se deteriora sau a expira rapid. Prin urmare, Clientul
          nu are dreptul să se retragă din Contract.
        </Paragraph>

        <Divider />

        <SectionTitle>Relația cu clienții</SectionTitle>

        <Paragraph>
          Pentru orice informație sau reclamație referitoare la Website sau la
          comenzi, Clienții au la dispoziție următoarele date de contact:
        </Paragraph>

        <List>
          <ListItem>
            Numărul de telefon <strong>0775 107 107</strong>
          </ListItem>
          <ListItem>
            Adresa de e-mail <strong>office@ahavacakes.ro</strong>
          </ListItem>
        </List>

        <Divider />

        <SectionTitle>Protecția datelor cu caracter personal</SectionTitle>

        <Paragraph>
          Ahava Cakes colectează, prin intermediul Website-ului, datele cu
          caracter personal ale Clientului. Clientul trebuie să consulte
          Politica de Confidențialitate aplicabilă Website-ului. Website-ul
          utilizează Cookies. Prin utilizarea Website-ului, Clientul este de
          acord și cu Politica Cookies.
        </Paragraph>

        <Divider />

        <SectionTitle>Proprietate intelectuală</SectionTitle>

        <Paragraph>
          Conținutul Website-ului este protejat de legile privind drepturile de
          proprietate intelectuală aplicabile, inclusiv Legea nr. 8/1996 privind
          drepturile de autor și drepturile conexe.
        </Paragraph>

        <Paragraph>
          Toate textele, imaginile, graficele, animațiile, instrumentele,
          aplicațiile, articolele, materialele, fotografiile, mărcile,
          denumirile comerciale și logourile, precum și alte materiale și
          informații de pe acest Website sunt protejate de drepturi de
          proprietate intelectuală ale Ahava Cakes și/sau ale partenerilor săi.
        </Paragraph>

        <Paragraph>
          Aceste materiale nu pot fi copiate, modificate, publicate, distribuite
          sau transferate în orice formă de către Client fără acordul prealabil
          scris al Ahava Cakes.
        </Paragraph>

        <Divider />

        <SectionTitle>Alte prevederi</SectionTitle>

        <Paragraph>
          Website-ul poate conține link-uri către alte website-uri/pagini web
          pentru utilizarea cărora se vor aplica termeni și condiții specifice,
          Ahava Cakes nefiind răspunzătoare pentru conținutul respectivelor
          website-uri.
        </Paragraph>

        <Divider />

        <SectionTitle>Despăgubiri</SectionTitle>

        <Paragraph>
          Clientul declară și recunoaște că este de acord să despăgubească și să
          exonereze de răspundere Ahava Cakes și partenerii săi contractuali
          pentru orice pierdere, solicitare și cheltuială rezultată din
          încălcarea acestor Termeni și Condiții sau din utilizarea
          necorespunzătoare a Website-ului.
        </Paragraph>

        <Divider />

        <SectionTitle>Forța majoră</SectionTitle>

        <Paragraph>
          Toate evenimentele de forță majoră definite de legislația română
          reprezintă un motiv de suspendare și stingere a obligațiilor Ahava
          Cakes.
        </Paragraph>

        <Divider />

        <SectionTitle>Reclamații și litigii</SectionTitle>

        <Paragraph>
          Acești Termeni și Condiții sunt supuși legislației din România. În caz
          de apariție a unor dispute, Clientul va putea depune reclamații la
          adresa de e-mail <strong>office@ahavacakes.ro</strong> pentru a ajunge
          la o soluționare amiabilă. În lipsa unei înțelegeri amiabile,
          litigiile vor fi soluționate de instanțele judecătorești competente.
        </Paragraph>

        <Paragraph>
          Prin utilizarea Website-ului vă exprimați în mod expres acordul cu
          privire la prevederile acestor Termeni și Condiții.
        </Paragraph>
      </Container>
    </PageWrapper>
  );
}
